/**
 * @generated SignedSource<<45ad9a3ff29ad79a13496322c6d115ff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FilteredSurveyInput = {
  PIISurveys?: boolean | null;
  historicSurveys?: boolean | null;
  trackingParams?: ReadonlyArray<TrackingParam | null> | null;
  webcamSurveys?: boolean | null;
};
export type TrackingParam = {
  key: string;
  value: string;
};
export type SurveyListRefetchQuery$variables = {
  input: FilteredSurveyInput;
};
export type SurveyListRefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useSurveyListFragmentQuery_surveysRef">;
};
export type SurveyListRefetchQuery = {
  response: SurveyListRefetchQuery$data;
  variables: SurveyListRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formatted",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SurveyListRefetchQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "useSurveyListFragmentQuery_surveysRef"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SurveyListRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SurveyConnection",
        "kind": "LinkedField",
        "name": "surveys",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalCount",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SurveyEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Survey",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "tags",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "iconUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CurrencyAmount",
                    "kind": "LinkedField",
                    "name": "rewardAmount",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "subUnitAmount",
                        "storageKey": null
                      },
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MoneyAmount",
                    "kind": "LinkedField",
                    "name": "baseReward",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cents",
                        "storageKey": null
                      },
                      (v4/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LockedSurveyInfo",
                    "kind": "LinkedField",
                    "name": "lockedInfo",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "supportId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DurationDetails",
                    "kind": "LinkedField",
                    "name": "durationDetails",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "providerDuration",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "studyId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AdminSurveyData",
                    "kind": "LinkedField",
                    "name": "adminData",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "rankScore",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "surveyGuid",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "statusDescription",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "surveyId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startedAt",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserData",
        "kind": "LinkedField",
        "name": "userData",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "443ca3d6c081fde4f7414a8d0a710c2f",
    "id": null,
    "metadata": {},
    "name": "SurveyListRefetchQuery",
    "operationKind": "query",
    "text": "query SurveyListRefetchQuery(\n  $input: FilteredSurveyInput!\n) {\n  ...useSurveyListFragmentQuery_surveysRef_2VV6jB\n}\n\nfragment useFinishedSurveyCardFragmentQuery_surveyRef on Survey {\n  id\n  title\n  status\n  statusDescription\n  supportId\n  surveyId\n  studyId\n  tags\n  startedAt\n  rewardAmount {\n    formatted\n  }\n  durationDetails {\n    providerDuration\n  }\n}\n\nfragment useSurveyCardFragmentQuery_surveyRef on Survey {\n  id\n  iconUrl\n  rewardAmount {\n    formatted\n    subUnitAmount\n    currency\n  }\n  baseReward {\n    cents\n    currency\n    formatted\n  }\n  lockedInfo {\n    title\n  }\n  title\n  url\n  status\n  supportId\n  durationDetails {\n    providerDuration\n  }\n  tags\n  studyId\n  adminData {\n    rankScore\n    surveyGuid\n  }\n}\n\nfragment useSurveyListFragmentQuery_surveysRef_2VV6jB on Query {\n  surveys(input: $input) {\n    pageInfo {\n      totalCount\n    }\n    edges {\n      node {\n        id\n        tags\n        status\n        url\n        ...useSurveyCardFragmentQuery_surveyRef\n        ...useFinishedSurveyCardFragmentQuery_surveyRef\n      }\n    }\n    id\n  }\n  userData {\n    firstName\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "0b4b410f2d9c84a4d969964b00e56040";

export default node;
